/** @file The main app for CodeGrade. */
import * as localforage from 'localforage';
// @ts-expect-error: This component doesn't have type declarations.
import * as memoryStorageDriver from 'localforage-memoryStorageDriver';
import Vue from 'vue';
import * as main from './main';
import polyfilled from './polyfills';
const DRIVERS = [
    localforage.INDEXEDDB,
    localforage.WEBSQL,
    localforage.LOCALSTORAGE,
    'memoryStorageDriver',
];
Promise.all([polyfilled, localforage.defineDriver(memoryStorageDriver)]).then(() => {
    Vue.prototype.$hlanguageStore = localforage.createInstance({
        name: 'highlightLanguageStore',
        driver: DRIVERS,
    });
    [Vue.prototype.$hlanguageStore].forEach(forageStore => {
        // `localForage` does some initialization on the first get, but when
        // doing two first gets at the same time (in different promise chains
        // for example) this creates a race condition that fails in Firefox in
        // private mode. So we initialize the stores here.
        try {
            forageStore.getItem('test key');
        }
        catch (_) {
            // PASS
        }
    });
    const app = main.makeApp();
    // @ts-expect-error: We are not allowed to assign to the window.
    // eslint-disable-next-line
    window.__app__ = app;
});
